import React, { useEffect, useState } from "react";
import styles from "./my.module.sass";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ShareIcon from "@mui/icons-material/Share";
import CONFIG from "../../../../Core/CONFIG/CONFIG";
import GameInjector from "../GameInjector";
import CONFIG from "../../../../Core/CONFIG/CONFIG";
import cn from 'classnames'
import { withRouter } from "react-router";

const Hero = ({game, onGameClick}) => {

    return (
        <>
        <div className={styles.hero}>
            {/* <img src={landscape} /> */}
            <iframe src={ 'https://www.youtube-nocookie.com/embed/' + game.videoUrl + "?playlist="+game.videoUrl+"&vq=hd1080&autohide=0&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&rel=0&showinfo=0&wmode=opaque&widgetid=1&autoplay=1&mute=1&version=3&loop=1&origin=https://www.supersnappy.io"} allowfullscreen="false" ></iframe>
            <div className={styles.titlebox}>
            <p className={styles.subtitle}>FEATURED</p>
            <h1 className={styles.title}>{game.name}</h1>
            </div>
            <button className={cn('button', styles.playbutton)} onClick={onGameClick}>PLAY</button>
            <button className={styles.overlayActioner} onClick={ onGameClick }/>
        </div>
        </>
    );
};

export default Hero;
